/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StopoversRouteImport } from './routes/stopovers'
import { Route as AroundTheWorldRouteImport } from './routes/around-the-world'
import { Route as IndexRouteImport } from './routes/index'
import { Route as Level1IndexRouteImport } from './routes/$level1/index'
import { Route as Level1Level2RouteImport } from './routes/$level1/$level2'

const StopoversRoute = StopoversRouteImport.update({
  id: '/stopovers',
  path: '/stopovers',
  getParentRoute: () => rootRouteImport,
} as any)
const AroundTheWorldRoute = AroundTheWorldRouteImport.update({
  id: '/around-the-world',
  path: '/around-the-world',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const Level1IndexRoute = Level1IndexRouteImport.update({
  id: '/$level1/',
  path: '/$level1/',
  getParentRoute: () => rootRouteImport,
} as any)
const Level1Level2Route = Level1Level2RouteImport.update({
  id: '/$level1/$level2',
  path: '/$level1/$level2',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/around-the-world': typeof AroundTheWorldRoute
  '/stopovers': typeof StopoversRoute
  '/$level1/$level2': typeof Level1Level2Route
  '/$level1/': typeof Level1IndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/around-the-world': typeof AroundTheWorldRoute
  '/stopovers': typeof StopoversRoute
  '/$level1/$level2': typeof Level1Level2Route
  '/$level1': typeof Level1IndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/around-the-world': typeof AroundTheWorldRoute
  '/stopovers': typeof StopoversRoute
  '/$level1/$level2': typeof Level1Level2Route
  '/$level1/': typeof Level1IndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/around-the-world'
    | '/stopovers'
    | '/$level1/$level2'
    | '/$level1/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/around-the-world' | '/stopovers' | '/$level1/$level2' | '/$level1'
  id:
    | '__root__'
    | '/'
    | '/around-the-world'
    | '/stopovers'
    | '/$level1/$level2'
    | '/$level1/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AroundTheWorldRoute: typeof AroundTheWorldRoute
  StopoversRoute: typeof StopoversRoute
  Level1Level2Route: typeof Level1Level2Route
  Level1IndexRoute: typeof Level1IndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/stopovers': {
      id: '/stopovers'
      path: '/stopovers'
      fullPath: '/stopovers'
      preLoaderRoute: typeof StopoversRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/around-the-world': {
      id: '/around-the-world'
      path: '/around-the-world'
      fullPath: '/around-the-world'
      preLoaderRoute: typeof AroundTheWorldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$level1/': {
      id: '/$level1/'
      path: '/$level1'
      fullPath: '/$level1/'
      preLoaderRoute: typeof Level1IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$level1/$level2': {
      id: '/$level1/$level2'
      path: '/$level1/$level2'
      fullPath: '/$level1/$level2'
      preLoaderRoute: typeof Level1Level2RouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AroundTheWorldRoute: AroundTheWorldRoute,
  StopoversRoute: StopoversRoute,
  Level1Level2Route: Level1Level2Route,
  Level1IndexRoute: Level1IndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
